/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class TimeOfDay {
  /**
  * Hour of the day.
  */
  'hour': number;
  /**
  * Minute of the hour.
  */
  'minute': number;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "hour",
      "baseName": "hour",
      "type": "number",
      "format": ""
    },
    {
      "name": "minute",
      "baseName": "minute",
      "type": "number",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return TimeOfDay.attributeTypeMap;
  }

  public constructor() {
  }
}

